import { FC, Fragment } from 'react';
import { Switch } from 'react-router-dom';
import { PrivateRoute } from '../router/components';
import RouteConstants from '../router/RouteConstants';
import { CreateDestinationV2, CreateCustomDestination } from './components/createDestination_v2';
import { DestinationsV2 } from './Destinations_V2';

export const DestinationsRouter: FC = () => (
  <Fragment>
    <Switch>
      <PrivateRoute path={RouteConstants.createDestination} component={CreateDestinationV2} />
      <PrivateRoute path={RouteConstants.createCustomDestination} component={CreateCustomDestination} />
      <PrivateRoute path={RouteConstants.destinations} component={DestinationsV2} />
    </Switch>
  </Fragment>
);
